import script from "./AutocompleteMulti.vue?vue&type=script&setup=true&lang=js"
export * from "./AutocompleteMulti.vue?vue&type=script&setup=true&lang=js"

import "./AutocompleteMulti.vue?vue&type=style&index=0&id=ca09f184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca09f184"]])

export default __exports__